import { render, staticRenderFns } from "./OzWallCard.vue?vue&type=template&id=5a756416&scoped=true&"
import script from "./OzWallCard.vue?vue&type=script&lang=ts&"
export * from "./OzWallCard.vue?vue&type=script&lang=ts&"
import style0 from "./OzWallCard.vue?vue&type=style&index=0&id=5a756416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a756416",
  null
  
)

export default component.exports